import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBayiDashboard_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBayiDashboard_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  DealerContextByKuserId: any[];
  DealerContextByKuserId_dummy: any[];
  SubDealerTop5List: any[];
  SubDealerTop5List_dummy: any[];
  SelectTop5ActiveCampanins: any[];
  SelectTop5ActiveCampanins_dummy: any[];
  SelectTop5IssuesByDealerId: any[];
  SelectTop5IssuesByDealerId_dummy: any[];
  SelectTop5DelaerGoalsByDealerId: any[];
  SelectTop5DelaerGoalsByDealerId_dummy: any[];
  GetBadgeByName: any[];
  GetBadgeByName_dummy: any[];
  IssueCountByDealerID: any[];
  IssueCountByDealerID_dummy: any[];
  CampaignsActiveCount: any[];
  CampaignsActiveCount_dummy: any[];
  SelectCurrentQuarter: any[];
  SelectCurrentQuarter_dummy: any[];
  pbDealerHomeByDealerId: any[];
  pbDealerHomeByDealerId_dummy: any[];
  SelectGoalIDByDealerId: any[];
  SelectGoalIDByDealerId_dummy: any[];
  OpenInBrowser: any;
  OpenInBrowser_dummy: any;
  isComp565145Visible: "visible" | "hidden";
  isComp707794Visible: "visible" | "hidden";
  isComp86564Visible: "visible" | "hidden";
  isCompbayidashboard_874344AuthorizationVisible: "visible" | "hidden";
}

export class BayiDashboard_ScreenBase extends React.PureComponent<
  IBayiDashboard_ScreenProps,
  any
> {
  bayidashboard_322670_value_kuikaSelectBoxRef: React.RefObject<any>;
  bayidashboard_565145_value_kuikaTableRef: React.RefObject<any>;
  bayidashboard_494072_value_kuikaCarouselRef: React.RefObject<any>;
  bayidashboard_971122_value_kuikaTableRef: React.RefObject<any>;
  bayidashboard_181911_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "9a8d38f6-1a76-4e72-a721-a317adeb2033",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 185228, PropertyName: "value", Value: "Merhaba," },
        { Id: 775767, PropertyName: "value", Value: "Açık Taleb" },
        { Id: 964248, PropertyName: "value", Value: "Kampanya" },
        { Id: 440612, PropertyName: "value", Value: "Hedefler" },
        { Id: 322670, PropertyName: "placeholder", Value: "Çeyrek Seç..." },
        { Id: 810351, PropertyName: "value", Value: "Tümü >" },
        { Id: 371372, PropertyName: "value", Value: "Satış Ciro" },
        { Id: 88394, PropertyName: "value", Value: "Yedek Parça Ciro" },
        { Id: 171246, PropertyName: "value", Value: "PowerBox Adet" },
        { Id: 805860, PropertyName: "title", Value: "Title" },
        { Id: 708538, PropertyName: "value", Value: "[datafield:name]" },
        { Id: 482220, PropertyName: "value", Value: "[datafield:description]" },
        { Id: 749504, PropertyName: "value", Value: "[datafield:typename]" },
        { Id: 308757, PropertyName: "value", Value: "Kampanyalar" },
        { Id: 332881, PropertyName: "value", Value: "Tümü >" },
        {
          Id: 494072,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 119195, PropertyName: "value", Value: "[datafield:title]" },
        { Id: 703102, PropertyName: "value", Value: "[datafield:content]" },
        {
          Id: 379506,
          PropertyName: "value",
          Value: "[datafield:campaigncode]",
        },
        { Id: 402727, PropertyName: "value", Value: "[datafield:startdate]" },
        { Id: 259608, PropertyName: "value", Value: "[datafield:enddate]" },
        { Id: 103740, PropertyName: "value", Value: "Alt Bayiler" },
        { Id: 427486, PropertyName: "value", Value: "Tümü >" },
        { Id: 244137, PropertyName: "title", Value: "Title" },
        { Id: 902852, PropertyName: "value", Value: "[datafield:dealername]" },
        { Id: 195009, PropertyName: "value", Value: "[datafield:vkn]" },
        { Id: 386508, PropertyName: "value", Value: "Talepler" },
        { Id: 811928, PropertyName: "value", Value: "Tümü >" },
        { Id: 188846, PropertyName: "title", Value: "Title" },
        { Id: 570348, PropertyName: "value", Value: "[datafield:status]" },
        { Id: 997053, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 229196, PropertyName: "value", Value: "[datafield:title]" },
        { Id: 326920, PropertyName: "value", Value: "[datafield:content]" },
        {
          Id: 446403,
          PropertyName: "value",
          Value: "[datafield:externallink]",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.bayidashboard_322670_value_kuikaSelectBoxRef = React.createRef();
    this.bayidashboard_565145_value_kuikaTableRef = React.createRef();
    this.bayidashboard_494072_value_kuikaCarouselRef = React.createRef();
    this.bayidashboard_971122_value_kuikaTableRef = React.createRef();
    this.bayidashboard_181911_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      DealerContextByKuserId: [],
      SubDealerTop5List: [],
      SelectTop5ActiveCampanins: [],
      SelectTop5IssuesByDealerId: [],
      SelectTop5DelaerGoalsByDealerId: [],
      GetBadgeByName: [],
      IssueCountByDealerID: [],
      CampaignsActiveCount: [],
      SelectCurrentQuarter: [],
      pbDealerHomeByDealerId: [],
      SelectGoalIDByDealerId: [],
      OpenInBrowser: "",
      dataSource_322670: [
        { key: "0", text: "Yıllık" },
        { key: "1", text: "1. Çeyrek" },
        { key: "2", text: "2. Çeyrek" },
        { key: "3", text: "3. Çeyrek" },
        { key: "4", text: "4. Çeyrek" },
      ],
      isComp565145Visible: "hidden",
      isComp707794Visible: "hidden",
      isComp86564Visible: "hidden",
      isCompbayidashboard_874344AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bayidashboard", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BayiDashboardPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompbayidashboard_874344AuthorizationVisible",
      ["dd98aee9-c152-2e15-25ab-011f8cef6b8b", "AltBayi"]
    );

    KuikaAppManager.calculateAndSetBodyHeight("bayidashboard", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Bayi", "AltBayi"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bayidashboard", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BayiDashboardPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      bayidashboard_874344_value:
        this.state.GetBadgeByName?.at?.(0)?.badge ?? undefined,
      bayidashboard_322670_value:
        this.state.SelectCurrentQuarter?.at?.(0)?.currentQuarter ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BayiDashboardPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KuserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      DelaerID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DealerID_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DealerId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DealerId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DelaerID_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      DealerID_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
      Quarter_10: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectCurrentQuarter !== undefined
            ? stateVars.SelectCurrentQuarter?.length > 0
              ? stateVars.SelectCurrentQuarter[0].currentQuarter
              : null
            : this.state.SelectCurrentQuarter?.length > 0
            ? this.state.SelectCurrentQuarter[0].currentQuarter
            : null
        ),
        "number"
      ),
      DealerId_10: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiDashboard/BayiDashboardPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DealerContextByKuserId = result?.data.dealerContextByKuserId;
    formVars.bayidashboard_62909_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealerContextByKuserId !== undefined
        ? stateVars.DealerContextByKuserId?.length > 0
          ? stateVars.DealerContextByKuserId[0].dealerName
          : null
        : this.state.DealerContextByKuserId?.length > 0
        ? this.state.DealerContextByKuserId[0].dealerName
        : null
    );
    stateVars.SubDealerTop5List = result?.data.subDealerTop5List;

    stateVars.isComp707794Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SubDealerTop5List !== undefined
            ? stateVars.SubDealerTop5List?.length > 0
              ? stateVars.SubDealerTop5List[0].id
              : null
            : this.state.SubDealerTop5List?.length > 0
            ? this.state.SubDealerTop5List[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp86564Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SubDealerTop5List !== undefined
            ? stateVars.SubDealerTop5List?.length > 0
              ? stateVars.SubDealerTop5List[0].id
              : null
            : this.state.SubDealerTop5List?.length > 0
            ? this.state.SubDealerTop5List[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.SelectTop5ActiveCampanins =
      result?.data.selectTop5ActiveCampanins;

    stateVars.SelectTop5IssuesByDealerId =
      result?.data.selectTop5IssuesByDealerId;

    stateVars.SelectTop5DelaerGoalsByDealerId =
      result?.data.selectTop5DelaerGoalsByDealerId;

    stateVars.SelectTop5DelaerGoalsByDealerId =
      result?.data.selectTop5DelaerGoalsByDealerId;

    stateVars.GetBadgeByName = result?.data.getBadgeByName;
    formVars.bayidashboard_874344_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBadgeByName !== undefined
        ? stateVars.GetBadgeByName?.length > 0
          ? stateVars.GetBadgeByName[0].badge
          : null
        : this.state.GetBadgeByName?.length > 0
        ? this.state.GetBadgeByName[0].badge
        : null
    );
    stateVars.IssueCountByDealerID = result?.data.issueCountByDealerID;
    formVars.bayidashboard_478157_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueCountByDealerID !== undefined
        ? stateVars.IssueCountByDealerID?.length > 0
          ? stateVars.IssueCountByDealerID[0].issueCount
          : null
        : this.state.IssueCountByDealerID?.length > 0
        ? this.state.IssueCountByDealerID[0].issueCount
        : null
    );
    stateVars.CampaignsActiveCount = result?.data.campaignsActiveCount;
    formVars.bayidashboard_801350_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsActiveCount !== undefined
        ? stateVars.CampaignsActiveCount?.length > 0
          ? stateVars.CampaignsActiveCount[0].campaignsActiveCount
          : null
        : this.state.CampaignsActiveCount?.length > 0
        ? this.state.CampaignsActiveCount[0].campaignsActiveCount
        : null
    );
    stateVars.SelectCurrentQuarter = result?.data.selectCurrentQuarter;
    formVars.bayidashboard_322670_value =
      stateVars.SelectCurrentQuarter !== undefined
        ? stateVars.SelectCurrentQuarter?.length > 0
          ? stateVars.SelectCurrentQuarter[0].currentQuarter
          : null
        : this.state.SelectCurrentQuarter?.length > 0
        ? this.state.SelectCurrentQuarter[0].currentQuarter
        : null;
    stateVars.pbDealerHomeByDealerId = result?.data.pbDealerHomeByDealerId;
    formVars.bayidashboard_752769_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroString
        : null
    );
    formVars.bayidashboard_43215_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroYuzde
        : null
    );
    formVars.bayidashboard_564210_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroString
        : null
    );
    formVars.bayidashboard_862490_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
        : null
    );
    formVars.bayidashboard_958927_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetString
        : null
    );
    formVars.bayidashboard_554061_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiDashboardPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiDashboardPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bayidashboard_62909_value = ReactSystemFunctions.toString(
      this,
      stateVars.DealerContextByKuserId !== undefined
        ? stateVars.DealerContextByKuserId?.length > 0
          ? stateVars.DealerContextByKuserId[0].dealerName
          : null
        : this.state.DealerContextByKuserId?.length > 0
        ? this.state.DealerContextByKuserId[0].dealerName
        : null
    );

    formVars.bayidashboard_874344_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetBadgeByName !== undefined
        ? stateVars.GetBadgeByName?.length > 0
          ? stateVars.GetBadgeByName[0].badge
          : null
        : this.state.GetBadgeByName?.length > 0
        ? this.state.GetBadgeByName[0].badge
        : null
    );

    formVars.bayidashboard_478157_value = ReactSystemFunctions.toString(
      this,
      stateVars.IssueCountByDealerID !== undefined
        ? stateVars.IssueCountByDealerID?.length > 0
          ? stateVars.IssueCountByDealerID[0].issueCount
          : null
        : this.state.IssueCountByDealerID?.length > 0
        ? this.state.IssueCountByDealerID[0].issueCount
        : null
    );

    formVars.bayidashboard_801350_value = ReactSystemFunctions.toString(
      this,
      stateVars.CampaignsActiveCount !== undefined
        ? stateVars.CampaignsActiveCount?.length > 0
          ? stateVars.CampaignsActiveCount[0].campaignsActiveCount
          : null
        : this.state.CampaignsActiveCount?.length > 0
        ? this.state.CampaignsActiveCount[0].campaignsActiveCount
        : null
    );

    formVars.bayidashboard_322670_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectCurrentQuarter !== undefined
        ? stateVars.SelectCurrentQuarter?.length > 0
          ? stateVars.SelectCurrentQuarter[0].currentQuarter
          : null
        : this.state.SelectCurrentQuarter?.length > 0
        ? this.state.SelectCurrentQuarter[0].currentQuarter
        : null
    );

    formVars.bayidashboard_752769_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroString
        : null
    );

    formVars.bayidashboard_43215_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroYuzde
        : null
    );

    formVars.bayidashboard_564210_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroString
        : null
    );

    formVars.bayidashboard_862490_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
        : null
    );

    formVars.bayidashboard_958927_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetString
        : null
    );

    formVars.bayidashboard_554061_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
        : null
    );

    stateVars.dataSource_565145 =
      stateVars.SelectTop5DelaerGoalsByDealerId ??
      this.state.SelectTop5DelaerGoalsByDealerId;

    stateVars.dataSource_494072 =
      stateVars.SelectTop5ActiveCampanins ??
      this.state.SelectTop5ActiveCampanins;
    stateVars.isComp707794Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SubDealerTop5List !== undefined
            ? stateVars.SubDealerTop5List?.length > 0
              ? stateVars.SubDealerTop5List[0].id
              : null
            : this.state.SubDealerTop5List?.length > 0
            ? this.state.SubDealerTop5List[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp86564Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SubDealerTop5List !== undefined
            ? stateVars.SubDealerTop5List?.length > 0
              ? stateVars.SubDealerTop5List[0].id
              : null
            : this.state.SubDealerTop5List?.length > 0
            ? this.state.SubDealerTop5List[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_971122 =
      stateVars.SubDealerTop5List ?? this.state.SubDealerTop5List;

    stateVars.dataSource_181911 =
      stateVars.SelectTop5IssuesByDealerId ??
      this.state.SelectTop5IssuesByDealerId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BayiDashboardComponent_569304_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "BayiList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_517434_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "HedefList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_398615_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "394232",
      null,
      "bottom",
      "true",
      "100vw",
      "50vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_322670_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Quarter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "bayidashboard_322670_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiDashboard/BayiDashboardComponent_322670_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.pbDealerHomeByDealerId = result?.data.pbDealerHomeByDealerId;
    formVars.bayidashboard_752769_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroString
        : null
    );
    formVars.bayidashboard_43215_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroYuzde
        : null
    );
    formVars.bayidashboard_564210_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroString
        : null
    );
    formVars.bayidashboard_862490_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
        : null
    );
    formVars.bayidashboard_958927_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetString
        : null
    );
    formVars.bayidashboard_554061_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiDashboardComponent_322670_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiDashboardComponent_322670_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.bayidashboard_752769_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroString
        : null
    );

    formVars.bayidashboard_43215_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].satisCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].satisCiroYuzde
        : null
    );

    formVars.bayidashboard_564210_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroString
        : null
    );

    formVars.bayidashboard_862490_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].yedekParcaCiroYuzde
        : null
    );

    formVars.bayidashboard_958927_value = ReactSystemFunctions.toString(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetString
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetString
        : null
    );

    formVars.bayidashboard_554061_percent = ReactSystemFunctions.value(
      this,
      stateVars.pbDealerHomeByDealerId !== undefined
        ? stateVars.pbDealerHomeByDealerId?.length > 0
          ? stateVars.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
          : null
        : this.state.pbDealerHomeByDealerId?.length > 0
        ? this.state.pbDealerHomeByDealerId[0].powerBoxAdetYuzde
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_810351_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DealerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BayiDashboard/BayiDashboardComponent_810351_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectGoalIDByDealerId = result?.data.selectGoalIDByDealerId;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BayiDashboardComponent_810351_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BayiDashboardComponent_810351_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "HedefGerceklesmeOran",
      "GoalD",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectGoalIDByDealerId !== undefined
            ? stateVars.SelectGoalIDByDealerId?.length > 0
              ? stateVars.SelectGoalIDByDealerId[0].goalId
              : null
            : this.state.SelectGoalIDByDealerId?.length > 0
            ? this.state.SelectGoalIDByDealerId[0].goalId
            : null
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "HedefGerceklesmeOran",
      "DealerID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.DealerContextByKuserId !== undefined
            ? stateVars.DealerContextByKuserId?.length > 0
              ? stateVars.DealerContextByKuserId[0].id
              : null
            : this.state.DealerContextByKuserId?.length > 0
            ? this.state.DealerContextByKuserId[0].id
            : null
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "HedefGerceklesmeOran",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_332881_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "KampanyaList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_302331_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "KampanyaDetay",
      "CampaignID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "bayidashboard_494072_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "KampanyaDetay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_427486_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "BayiList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_761207_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BayiProfil",
      "DealerID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "bayidashboard_971122_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "BayiProfil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_811928_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "TalepList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_446403_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.OpenInBrowser = await ReactSystemFunctions.openInBrowser(
      ReactSystemFunctions.value(
        this,
        "bayidashboard_181911_value",
        "externalLink"
      ),
      ReactSystemFunctions.convertToTypeByName("", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BayiDashboardComponent_876714_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TalepDetay",
      "IssueID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "bayidashboard_181911_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BayiDashboard",
      "TalepDetay",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 394232, , , , , , ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BayiDashboardPageInit();
    }
  }
}
